export default __webpack_public_path__ + "static/5-pharmacy-details-8683f008bdf36858ced04ce3c4a6e573.jpg";